
import { ExamQuestionSignalr } from './exam-question-signalr';

export class ExamQuestionGeneratedSignalrMessage {
  examGenerationUniqueID: string;
  batchID: string;
  chunkStartIndex: string;
  chunkEndIndex: string[];
  question: ExamQuestionSignalr;
}